import logo from '../../assets/images/logo.svg'
import { TermsModal } from '../../components/molecules'
import pdf from '../../assets/documents/terms-of-use.pdf'
import { ReactElement, useCallback, useEffect } from 'react'
import apiServices, { updateUserProfile } from '../../libs/services'
import { useAuth } from '../../hooks/useAuth'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { PageTitle, SkipLink } from '../../components/atoms'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { setInstitution } from '../../redux/slices/institutionSlice'

export const pageTitle = 'Privacy and Terms of Use Agreement'
export const idTermsPageMainContent = 'welcome-page-main-content'

const Terms = (): ReactElement => {
  const { userProfile, setUserProfile } = useAuth()
  const { institution } = useSelector((state: RootState) => state.institution)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const navigateAfterTerms = useCallback(async () => {
    if (userProfile?.role?.slug === 'admin') {
      navigate('/dashboard/all-assigned-students')
      return
    }

    let currentInstitution = institution

    // If institution data is not in Redux, fetch it
    if (currentInstitution === null) {
      try {
        const res = await apiServices.getAccount()
        currentInstitution = res?.data?.account
        if (currentInstitution !== undefined && currentInstitution !== null) {
          dispatch(setInstitution(currentInstitution))
        }
      } catch (err) {
        console.error('Failed to fetch account for survey activation check.', err)
      }
    }

    // If the flag is ON, redirect to the pre-survey
    if (currentInstitution?.displaySurvey === true) {
      navigate('/presurvey')
    } else {
      navigate('/user-dashboard')
    }
  }, [dispatch, institution, navigate, userProfile])

  useEffect(() => {
    if (userProfile === null || userProfile === undefined) {
      navigate('/')
    } else if (userProfile?.user_profile?.accepted_terms) {
      void navigateAfterTerms()
    }
  }, [userProfile, navigate, navigateAfterTerms])

  const handleAcceptTerms = useCallback((setIsSubmitting: React.Dispatch<boolean>) => {
    setIsSubmitting(true)
    updateUserProfile({ accepted_terms: true })
      .then((res) => {
        if (res !== null || res !== undefined) {
          const updatedProfile = res?.data?.data
          setUserProfile({ ...userProfile, user_profile: updatedProfile })
          void navigateAfterTerms()
        } else {
          toast.error('Unable to update user profile', {
            position: toast.POSITION.TOP_CENTER
          })
        }
        setIsSubmitting(false)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER
        })
        setIsSubmitting(false)
      })
  }, [navigateAfterTerms, setUserProfile, userProfile])
  return (
    <div className='bg-black min-h-screen font-primary items-center flex justify-center'>
      <SkipLink targetId={idTermsPageMainContent} />
      <header className='absolute left-[40px] top-[40px]'>
        <img src={logo} className='w-[138px]' alt='DopaGE Logo' />
      </header>

      <main
        id={idTermsPageMainContent}
        tabIndex={-1}
      >
        <PageTitle title={pageTitle} />
        <section className='flex justify-center'>
          <TermsModal pdfUrl={pdf} handleAcceptTerms={handleAcceptTerms} />
        </section>
      </main>
      <footer className='sr-only' />
    </div>
  )
}

export default Terms
